import { Location } from "@angular/common";
import { Component, Optional, QueryList, ViewChildren } from '@angular/core';
import { IonRouterOutlet, Platform, AlertController, ToastController } from '@ionic/angular';
import { Router, NavigationEnd } from '@angular/router';
import { Network } from '@ionic-native/network/ngx';
import { Globalization } from '@ionic-native/globalization/ngx';
import { TranslateService } from "@ngx-translate/core";
import { Howl } from 'howler'
import OneSignal from 'onesignal-cordova-plugin';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  @ViewChildren(IonRouterOutlet)
  routerOutlets!: QueryList<IonRouterOutlet>;
  private lastTimeBackButtonWasPressed = 0;
  private timePeriodToAction = 2000;
  private language = "";
  successplayer;

  constructor( 
    private network: Network,
    private alertController: AlertController,
    private platform: Platform,
    public toastController: ToastController,
    private globalization: Globalization,
    private _translate: TranslateService
    ) {
      this.platform.ready().then(async () => {
        this.successplayer = new Howl({
          src: ["assets/sounds/successupdated.wav"],
        });
        this.networkStatus()
        this.setNotification()
        if(localStorage.getItem("language_select"))
        {
         this.language = localStorage.getItem("language_select")
         this._initTranslate(this.language)
        }
        else
         this.getDeviceLanguage()
      })

      

      this.platform.backButton.subscribe(() => {
        if(this.routerOutlets && this.routerOutlets.length>0)
        {
          this.routerOutlets.forEach((outlet: IonRouterOutlet) => {
          if (outlet && outlet.canGoBack()) 
          {
            outlet.pop();
          } 
          else  
          {
            this.withDoublePress(this.getTranslation("general.exit"), () => {
              (<any>navigator)['app'].exitApp();
            });
          }
      });
      }
      });
      
  }

  networkStatus() {
    this.network.onDisconnect().subscribe(() => {
      this.presentToast({
        position: 'bottom',
        message: this.getTranslation("general.offline"),
      });
    });

    this.network.onConnect().subscribe(() => {
      this.presentToast({
        position: 'bottom',
        message: this.getTranslation("general.online"),
      });
    });
  }

  async presentToast(resource: any = {}) {

    const closeButton = {
      side: 'end', 
      role: 'close', 
      icon: 'close',
      handler: () => {},
    };

    if(resource.hasOwnProperty('canDismiss')){
      resource['duration'] = 0;
      if(resource['buttons'] && resource['buttons'].length > 0){
        resource['buttons'].push(closeButton)
      }else{
        resource['buttons'] = [
          closeButton
        ];
      }
    }

    if(!resource.hasOwnProperty('duration')){
      resource['duration'] = 6000;
    }

    const toast = await this.toastController.create({
      cssClass: 'ion-custom-toast',
      header: resource?.header || '',
      message: resource?.message || '',
      duration: resource.duration,
      position: resource?.position || 'top',
      color: resource?.color || 'dark',
      buttons: resource?.buttons || [],
      
    });
    await toast.present();

    const { role } = await toast.onDidDismiss();
    if (resource.callback) {
      resource.callback(role);
    }
  }

  async withDoublePress(message: string, action: () => void) {
    if (new Date().getTime() - this.lastTimeBackButtonWasPressed < this.timePeriodToAction) {
      action();
    } else {
      const toast = await this.toastController.create({
        message: message,
        duration: this.timePeriodToAction
      });
      await toast.present();
      this.lastTimeBackButtonWasPressed = new Date().getTime();
    }
  }

 
  getDeviceLanguage() {
    if (window.Intl && typeof window.Intl === 'object') {
      this._initTranslate(navigator.language.split("-")[0])
    }
    else {
      this.globalization.getPreferredLanguage()
        .then(res => {
          this._initTranslate(res.value.split("-")[0])
        })
        .catch(e => {console.log(e);});
    }
  }

  _translateLanguage(): void {
    localStorage.setItem("language_select",this.language)
    this._translate.use(this.language);
  }

  _initTranslate(language) {
    this._translate.setDefaultLang('en');
    if (language) {
      this.language = language;
    }
    else {
      this.language = 'en';
    }
    this._translateLanguage();
  }

  getTranslation(key)
  {
    return this._translate.instant(key)
  }

  
  setNotification() {
    try {
      OneSignal.initialize("f849b56b-b442-41ac-b593-1d684dc4bd36");
      OneSignal.Notifications.requestPermission(true).then((accepted: any) => {
        console.log("User accepted notifications: " + accepted);
      });
      OneSignal.Notifications.addEventListener("click",  (event: any) =>{
        this.presentToast({
          canDismiss:false,
          header: event.notification.title,
          message: event.notification.body,
          color: 'success',
          position: 'top',
        });
      });
      OneSignal.Notifications.addEventListener("foregroundWillDisplay", (event: any) => {
        event.preventDefault()
        let notification_data = event.getNotification()
        this.presentToast({
          canDismiss:false,
          header: notification_data.title,
          message: notification_data.body,
          color: 'success',
          position: 'top',
        });
        this.successplayer.play();
      });
      
    } catch (error) {
      
    }
  }

}
